const item = "cui-popover-item-uosc";
const icon = "cui-popover-icon-wryn";
const trigger = "cui-popover-trigger-q5qn";
const menu = "cui-popover-menu-qtvw";
const open = "cui-popover-open-ncwp";
const divider = "cui-popover-divider-fpsh";
const overlay = "cui-popover-overlay-fxgt";
const wrapper = "cui-popover-wrapper-hx9a";
const classes = {
  item,
  icon,
  trigger,
  menu,
  open,
  divider,
  overlay,
  wrapper
};
export {
  classes as default,
  divider,
  icon,
  item,
  menu,
  open,
  overlay,
  trigger,
  wrapper
};
